import { createFileRoute, redirect } from '@tanstack/react-router';
import PermissionsService, {
  PERMISSION_COST_CENTERS,
  PERMISSION_PARKING_TAG,
  PERMISSION_RIDE_TAG,
} from '../../Services/PermissionsService';

export const Route = createFileRoute('/_authenticated/system_settings/')({
  beforeLoad: ({ context }) => {
    const selectedCustomers = context.selectedCustomers;

    if (PermissionsService.hasAccess(PERMISSION_RIDE_TAG, ['read'], selectedCustomers)) {
      throw redirect({ to: '/system_settings/ride-tag' });
    }
    if (PermissionsService.hasAccess(PERMISSION_PARKING_TAG, ['read'], selectedCustomers)) {
      throw redirect({ to: '/system_settings/parking-tag' });
    }
    if (PermissionsService.hasAccess(PERMISSION_COST_CENTERS, ['read'], selectedCustomers)) {
      throw redirect({ to: '/system_settings/cost-centers' });
    }

    throw redirect({ to: '/unauthorized' });
  },
  component: () => null,
});
